<template>
  <div class="expand">
    <div class="file_list">
      <div
        v-for="(item, index) in List"
        :key="index"
        class="file_list_item"
        :class="{ 'type-3 ': (index + 1) % 3 === 0 }"
        @click="toNext(item)"
      >
        <img src="../../assets/alicon/folder.png" alt="" class="file_list_item_img" />
        <img v-if="item.type_id === 1" src="../../assets/alicon/imgicon.png" alt="" class="img_icon" />
        <img v-if="item.type_id === 2" src="../../assets/alicon/videoicon.png" alt="" class="img_icon" />
        <img v-if="item.type_id === 3 || item.type_id === 4 || item.type_id === 5" src="../../assets/alicon/audioicon.png" alt="" class="img_icon" />
        <div class="file_list_item_name">{{ item.name }}</div>
      </div>
    </div>

    <div class="home_btn">
        <van-button type="info" size="middle" @click="isShow=true" class="btn_sync"> 
            创建文件夹 
        </van-button>
    </div>


    <van-dialog 
        v-model="isShow"
        title="新建文件夹" 
        show-cancel-button 
        :lazy-render="false"
        @confirm="newFolder"
    >
        <van-field
            type="textarea"
            rows="2"
            autosize
            autofocus
            v-model="form.name"
            maxlength="10"
            placeholder="请输入文件夹名称"
            show-word-limit
            class="message"
        />
    </van-dialog>

    <!--  -->
    <van-overlay :show="isLoading">
        <div class="wrapper" @click.stop>
            <van-loading type="spinner" />
        </div>
    </van-overlay>
  </div>
</template>

<script>
import { 
  GetFileCategory,
  PostFileCategory 
} from '@/api/index';
import { Toast } from 'vant-green';
export default {
  name: 'expand',
  components: {
  },
  data() {
    return {
      pageType: 1,
      // 1 图片 2 视频 3 音频 4 ai配音 5用户上传的配音
      List: [
        // {
        //   name: '这是文件这是文件',
        //   type_id: 3,
        // },
        // {
        //   name: '2',
        //   type_id: 3,
        // }
      ],
      isShow:false,
      isLoading: false,
      form:{
        type_id: 1,
        name:''
      }
    };
  },
  computed: {},

  created() {
    document.title = '素材库';
    this.init()
  },

  methods: {
    // 初始化
    init() {
      // http://file-front.zwstk.cn?username=zmxagent
      this.isLoading = true
      const urlParams = new URLSearchParams(window.location.search);
      this.pageType = urlParams.get('type');
      if(this.pageType){
        this.gstFileList(this.pageType)
      } else {
        this.$router.push({
          path: '/404',
          replace: true,
        });
      }
      setTimeout(() => {
        this.isLoading = false
      }, 500);
    },

    // 获取文件列表
    gstFileList(type_id) {
      GetFileCategory({ type_id: type_id }).then((res) => {
        this.List = res.data
        this.form.name = ''
      })
    },

    // 新建文件夹
    newFolder(){
      if(this.form.name){
        this.form.type_id = this.pageType
        PostFileCategory(this.form).then((res) => {
          this.gstFileList(this.pageType);
        });
      } else {
        Toast('文件名称不能为空！');
      }
    },

    // 前往下一级
    toNext(item) {
      this.$router.push({
        path: '/detail?type=' + item.type_id + '&id=' + item.id,
        replace: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.expand {
  width: 100%;
  height: 100%;
  position: relative;
  .file_list {
    position: relative;
    top: 50px;
    // padding-left: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // justify-content: space-around;
    .file_list_item {
      position: relative;
      margin-bottom: 20px;
      width: 33%;
      text-align: center;
      // border: 1px solid red;
      // width: 102px;
      // margin-right: 25px;
      // height: 100px;
      .file_list_item_img {
        // width: 90px;
        // height: 70px;
        width: 80%;
        height: auto;
      }
      .img_icon {
        position: absolute;
        // top: 20px;
        // left: 30px;
        // width: 40px;
        // height: 40px;
        width: 56px;
        height: 56px;
        left: 0;
        right: 0;
        margin: auto;
        top: 30px;
      }
      .file_list_item_name {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 90%; // 根据需要调整最大宽度
      }
    }
    .type-3 {
      margin-right: 0px;
    }
  }

  .home_btn {
    position: fixed;
    left: 0;
    bottom: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .btn_sync {
      width: 180px;
    }
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>

<style lang="scss">
.message {
  .van-field {
    border: 1px solid #e2e2e2;
    width: 90%;
    text-align: center;
    margin: 12px auto 28px auto;
    background: #f6f6f6;
  }
}
</style>
